<template>
  <div class="container">
    <sys-dialog
      v-show="dialogVisible"
      :bgi="dialogBgi"
      :show-close="true"
      :error-msg="errorMsg"
      @close="closeDialog"
    />

    <sys-dialog
      v-show="renderDialogVisible"
      :show-close="false"
      :hasNoMaxWidth="true"
      @close="closeDialog"
    >
      <img style="width: 375px;" :src="dialogImg"  alt="888b"/>
    </sys-dialog>

    <sys-loading :loading="loading" />

    <div :class="isMobile ? 'root' : 'content'">
      <div class="main">
        <div class="form-wrap">
          <div :class="isMobile ? 'form-container isMobile' : 'form-container'">
            <div class="logo">
              <img src="../assets/sport8/logo.png" alt="" />
            </div>
            <div class="euro">
              <img src="../assets/sport8/euro.png" alt="" />
            </div>
            <div :class="isRegisterAction ? 'form' : 'form login'">
              <div class="tags">
                <span
                  :class="
                    isRegisterAction ? 'tag register active' : 'tag register'
                  "
                  @click="
                    () => {
                      switchTab(true);
                    }
                  "
                ></span>
                <span
                  :class="!isRegisterAction ? 'tag active' : 'tag'"
                  @click="
                    () => {
                      switchTab(false);
                    }
                  "
                ></span>
              </div>

              <div class="inputs">
                <div class="form-input">
                  <div class="form-input__item">
                    <img src="../assets/sport8/icon-user.png" />
                    <input
                      v-model="form.username"
                      placeholder="Tên đăng nhập"
                      maxlength="20"
                      autocomplete="off"
                      @blur="() => onBlur('username')"
                      @change="() => onKeyup('username')"
                      @keyup="() => onKeyup('username')"
                    />
                  </div>
                  <span class="errMsg">{{ formErrMsg.username }}</span>
                </div>

                <div
                  class="form-input"
                  :style="!isRegisterAction ? { marginBottom: 0 } : ''"
                >
                  <div class="form-input__item">
                    <img src="../assets/sport8/icon-passwd.png" />
                    <input
                      v-model="form.password"
                      type="password"
                      minlength="4"
                      maxlength="15"
                      autocomplete="new-password"
                      placeholder="Mật khẩu"
                      @blur="() => onBlur('password')"
                    />
                  </div>
                  <span class="errMsg">{{ formErrMsg.password }}</span>
                  <a
                    v-if="!isRegisterAction"
                    class="error"
                    href="https://www.888b.com"
                    >Quên Mật Khẩu?</a
                  >
                </div>

                <div class="form-input" v-show="isRegisterAction">
                  <div class="form-input__item">
                    <img src="../assets/sport8/icon-passwd.png" />
                    <input
                      v-model="form.rePassword"
                      placeholder="Nhập lại mật khẩu"
                      type="password"
                      minlength="4"
                      maxlength="15"
                      autocomplete="new-password"
                      @blur="() => onBlur('repassword')"
                    />
                  </div>
                  <span class="errMsg">{{ formErrMsg.rePassword }}</span>
                </div>

                <div class="form-input" v-show="isRegisterAction">
                  <div class="form-input__item">
                    <img src="../assets/sport8/icon-code.png" alt="name" />
                    <input
                      v-model="form.verificationCode"
                      oninput="value=value.replace(/[\W]/g, '')"
                      placeholder="Mã xác minh"
                      @blur="() => onBlur('code')"
                    />

                    <span class="form-input__code">
                      <img
                        class="w-full h-full"
                        v-show="captchaImg"
                        :src="captchaImg"
                        @click="getCode"
                        alt="code"
                      />
                    </span>
                  </div>
                  <span class="errMsg">{{ formErrMsg.code }}</span>
                </div>

                <v-captcha
                  ref="vcaptcha1"
                  :dialogVisible="dialogVisible"
                  :showCheck="showCheck"
                  @cb="handleConfirm"
                  :vstyle="
                    isMobile
                      ? {
                          width: '50%',
                          height: '18%',
                          position: 'absolute',
                          left: '25%',
                          bottom: '-6%'
                        }
                      : {
                          width: '50%',
                          height: '18%',
                          position: 'absolute',
                          left: '25%',
                          bottom: 0
                        }
                  "
                  :nativeButton="
                    isMobile
                      ? {
                          width: '100%',
                          height: '47px'
                        }
                      : {
                          width: '100%',
                          height: '65px'
                        }
                  "
                >
                  <div
                    v-show="isRegisterAction"
                    class="submitBtn reg"
                    @click="submitAction(1)"
                  >
                    <img src="../assets/sport8/register-btn.gif" />
                  </div>
                </v-captcha>

                <div
                  v-show="!isRegisterAction"
                  class="submitBtn login"
                  @click="submitAction(2)"
                >
                  <img src="../assets/sport8/login-btn.gif" />
                </div>

                <div class="bottom-tips" v-if="isRegisterAction">
                  <span>Bạn đã có tài khoản ?</span>
                  <span style="color: #DAFC0A">Đăng nhập ngay</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-banner">
          <div class="grid">
            <div class="w-full h-full">
              <img
                class="w-full h-full"
                src="../assets/sport8/footer-banner1.png"
                alt=""
              />
            </div>
            <div class="w-full h-full">
              <img
                class="w-full h-full"
                src="../assets/sport8/footer-banner2.png"
                alt=""
              />
            </div>
            <div class="w-full h-full">
              <img
                class="w-full h-full"
                src="../assets/sport8/footer-banner3.png"
                alt=""
              />
            </div>
            <div class="w-full h-full">
              <img
                class="w-full h-full"
                src="../assets/sport8/footer-banner4.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "amfe-flexible";
import md5 from "js-md5";
import { swiper, swiperSlide } from "vue-awesome-swiper";

import {
  FORM_VALID_MESSAGE,
  DOMAIN_INVITE_CODE,
  DOMAIN_AGENT_LINE
} from "../utils/constant";
import {
  userRegister,
  userLogin,
  getCapCode,
  createCustomer,
  sendEndPoint
} from "../utils/request";
import {
  encodePlatformUrl,
  validForm,
  isMobile,
  replacePhonePrefix
} from "../utils/tools";
import { captcha } from "@/mixins/captcha";

const check = {
  //邮箱
  email: /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/,
  // 用户名
  username: /^[0-9a-zA-Z]{4,20}$/,
  // 用户密码
  password: /^[0-9a-zA-Z!~!@#$%^&*.,?]{6,15}$/
};

export default {
  name: "Sport",
  mixins: [captcha],
  components: { swiper, swiperSlide },
  data() {
    return {
      captchaImg: "",

      renderDialogVisible: false,
      isMobile: isMobile(),
      swiperMobileVisible: false,
      isRegisterAction: true,
      dialogVisible: false,
      loading: false,

      dialogImg: require("../assets/sport8/register-success-new.png"),
      dialogBgiRegister: require("../assets/sport8/register-success-new.png"),
      dialogBgiLogin: require("../assets/sport5/login-success-new.png"),
      dialogBgi: require("../assets/sport4/bgi-dialog.png"),

      form: {
        by: 1,
        username: "",
        phone: "",
        password: "",
        email: "",
        link: "",
        domain: "",
        inviteCode: null
      },
      formErrMsg: {
        username: null,
        password: null,
        phone: null,
        email: null
      },
      errorMsg: {
        title: "",
        content: ""
      },
      closeImage: require("../assets/sport5/close-dialog.png"),
      swiperImages: [
        require("../assets/sport5/swiper-1.png"),
        require("../assets/sport5/swiper-2.png"),
        require("../assets/sport5/swiper-3.png"),
        require("../assets/sport5/swiper-4.png")
      ],
      swiperImagesLeft: [
        require("../assets/sport5/swiper-1.png"),
        require("../assets/sport5/swiper-2.png")
      ],
      swiperImagesRight: [
        require("../assets/sport5/swiper-3.png"),
        require("../assets/sport5/swiper-4.png")
      ]
    };
  },
  mounted() {
    this.getCode();
    this.swiperMobileVisible = isMobile() && window.innerWidth > 360;
    window.onresize = () => {
      this.isMobile = isMobile();
      this.swiperMobileVisible = this.isMobile && window.innerWidth > 360;
    };
  },
  methods: {
    getCode() {
      getCapCode()
        .then(res => {
          if (!res.body.code) {
            this.captchaImg = res.body.data;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    onKeyup(key) {
      if (key === "username") {
        this.form.username = this.form.username.replace(/[\W]/g, "");
      }
    },
    switchTab(flag) {
      this.errMsg = {
        username: null,
        password: null,
        phone: null,
        email: null
      };
      this.isRegisterAction = flag;
    },
    onBlur(key) {
      if (key === "username") {
        this.form.username = this.form.username.replace(/[\W]/g, "");
        if (!this.form.username) {
          this.formErrMsg.username = "*Vui lòng nhập tên đăng nhập";
        } else if (!check.username.test(this.form.username)) {
          this.formErrMsg.username = "4 - 20 ký tự gồm số và chữ";
        } else {
          this.formErrMsg.username = null;
        }
      }

      if (key === "password") {
        if (!this.form.password) {
          this.formErrMsg.password = "*Vui lòng nhập mật khẩu";
        } else if (!check.password.test(this.form.password)) {
          this.formErrMsg.password = "*Mật khẩu phải từ 6 đến 15 ký tự";
        } else {
          this.formErrMsg.password = null;
        }
      }

      if (key === "repassword") {
        if (!this.form.rePassword) {
          this.formErrMsg.rePassword = "* Vui lòng nhập lại mật khẩu";
        } else if (this.form.rePassword.length < 6) {
          this.formErrMsg.rePassword = "Mật khẩu không trùng khớp";
        } else if (!check.password.test(this.form.rePassword)) {
          this.formErrMsg.rePassword = "*Số điện thoại không đúng định dạng";
        } else if (this.form.rePassword !== this.form.password) {
          this.formErrMsg.rePassword = "*Mật khẩu không trùng khớp";
        } else {
          this.formErrMsg.rePassword = null;
        }
      }

      if (key === "phone") {
        const reg = /^\d{10,11}$/;
        if (!this.form.phone) {
          this.formErrMsg.phone = "*Vui lòng nhập số điện thoại";
        } else if (!reg.test(this.form.phone)) {
          this.formErrMsg.phone = "*Số điện thoại không đúng định dạng";
        } else {
          this.formErrMsg.phone = null;
        }
      }

      if (key === "email") {
        if (!this.form.email) {
          this.formErrMsg.email = "*Vui lòng nhập Email";
        } else if (
          !["", null, "null"].includes(this.form.email) &&
          (!/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(
            this.form.email
          ) ||
            !(
              String(this.form.email)
                .toLowerCase()
                .indexOf("@gmail.com") > -1 ||
              String(this.form.email)
                .toLowerCase()
                .indexOf("@yahoo.com") > -1
            ))
        ) {
          this.formErrMsg.email = "*Chỉ chấp nhận email @gmail.com, @yahoo.com";
        } else {
          this.formErrMsg.email = null;
        }
      }
    },
    closeDialogLogin() {
      this.dialogLoginVisible = false;
    },
    showDialogLogin() {
      this.dialogLoginVisible = true;
    },
    submitAction(type) {
      console.log("🚀 ~ submitAction ~ type:", type);
      let errorMsg = validForm(type, this.form);

      if (type === 1) {
        //  注册校验
        // 用户名
        if (!this.form.username) {
          this.formErrMsg.username = "*Vui lòng nhập tên đăng nhập";
          return;
        } else if (!check.username.test(this.form.username)) {
          this.formErrMsg.username = "4 - 20 ký tự gồm số và chữ";
          return;
        }
        // 密码
        if (!this.form.password) {
          this.formErrMsg.password = "*Vui lòng nhập mật khẩu";
          return;
        } else if (!check.password.test(this.form.password)) {
          this.formErrMsg.password = "*Mật khẩu phải từ 6 đến 15 ký tự";
          return;
        }
      } else if (type === 2) {
        // 登陆校验
        // 用户名
        if (!this.form.username) {
          this.formErrMsg.username = "*Vui lòng nhập tên đăng nhập";
          return;
        } else if (!check.username.test(this.form.username)) {
          this.formErrMsg.username = "4 - 20 ký tự gồm số và chữ";
          return;
        }
        // 密码
        if (!this.form.password) {
          this.formErrMsg.password = "*Vui lòng nhập mật khẩu";
          return;
        } else if (!check.password.test(this.form.password)) {
          this.formErrMsg.password = "*Mật khẩu phải từ 6 đến 15 ký tự";
          return;
        }
      }

      // if (Object.keys(errorMsg).length !== 0) {
      //   this.setDialogMsg(errorMsg.title, errorMsg.content);
      //   return;
      // }
      this.loading = true;
      // 登陆
      if (type == 2) {
        let temp = Object.assign({}, this.form);
        let params = {
          acctType: 6,
          by: 1,
          email: temp.email,
          userName: temp.username,
          password: md5(temp.password)
        };
        this.login(params);
      } else {
        const inviteCode = DOMAIN_INVITE_CODE[location.host] || "";
        this.form.inviteCode = inviteCode;
        this.form.domain = location.host;
        this.form.userName = this.form.username;
        this.register();
      }
    },
    login(params) {
      userLogin(params)
        .then(res => {
          if (res.data.code == 0) {
            this.dialogLoginVisible = false;
            this.renderDialogVisible = true;
            this.dialogImg = this.dialogBgiLogin;
            setTimeout(() => {
              location.href = encodePlatformUrl(
                this.form.username,
                this.form.password
              );
            }, 5000);
          } else {
            this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, res.data.msg);
          }
          this.loading = false;
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, error.data);
          this.loading = false;
        });
    },
    register() {
      this.params = Object.assign({}, this.form);
      // let params = (this.params = Object.assign({}, this.form));
      // if (!/^[0-9a-zA-Z!~!@#$%^&*.,?]{6,15}$/.test(params.password)) {
      //   this.setDialogMsg(
      //     FORM_VALID_MESSAGE.registerFailTitle,
      //     FORM_VALID_MESSAGE.passwordMsg
      //   );
      //   this.loading = false;
      //   return;
      // }
      this.handleCheck(this.handleConfirm);
    },
    handleConfirm(params = this.params) {
      params.phone =
        params.phone.length == 10
          ? params.phone
          : replacePhonePrefix(params.phone);
      params.userName = params.userName.toLowerCase();
      params.password = md5(params.password);
      userRegister(params, this.captchaParams)
        .then(res => {
          if (res.data.code == 0) {
            this.dialogLoginVisible = false;
            this.renderDialogVisible = true;
            this.dialogImg = this.dialogBgiRegister;
            createCustomer(this.form);
            setTimeout(() => {
              location.href = encodePlatformUrl(
                this.form.username,
                this.form.password
              );
            }, 5000);
          } else {
            this.setDialogMsg(
              FORM_VALID_MESSAGE.registerFailTitle,
              res.data.msg
            );
            this.handleOpen(res.data.code);
            this.getCode();
          }
          this.loading = false;
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.registerFailTitle, error.data);
          this.loading = false;
          this.getCode();
        });
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    setDialogMsg(title, msg) {
      this.errorMsg.title = title;
      this.errorMsg.content = msg;
      this.dialogVisible = true;
    }
  }
};
</script>

<style lang="less" scoped>
@import "../assets/less/common.less";

::-webkit-input-placeholder {
  color: #ffffff;
}

// 通用文件
.content,
.root {
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

// 电脑端
.content {
  background-image: url("../assets/sport8/bgi-pc.png");
  background-size: 100% 100%;
  height: 100vh;
  overflow: hidden;
  .main {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    box-sizing: border-box;
    position: relative;

    .form-wrap {
      height: 4.167rem;
      width: 100%;
      position: relative;
      .logo {
        text-align: center;
        img {
          height: 100px;
        }
      }
      .euro {
        text-align: center;
        margin-bottom: 0.323rem;
        img {
          height: 0.458rem;
        }
      }
      .form-container {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0.521rem;
      }
    }
  }
}

// 手机端
.root {
  height: 24.8rem;
  min-height: 100vh;
  background-image: url("../assets/sport8/bgi-h5.png");
  background-size: 100% 100%;
  .bottom-banner {
    .grid {
      grid-template-columns: repeat(2, 4.08rem);
    }
  }
  .main {
    display: flex;
    flex-flow: column;
    align-items: center;
    // padding-top: 5vw;
    position: relative;
    padding-top: 0.25rem;
  }

  .logo {
    height: 1.507rem;
    text-align: center;
    > img {
      height: 100%;
    }
  }
  .euro {
    width: 7.7rem;
    height: 2.067rem;
    text-align: center;
    > img {
      height: 100%;
    }
  }
  .tags {
    top: -0.3rem !important;
  }
}

/deep/ .close-img {
  width: 40px;
  height: 40px;
  opacity: 0;
  top: 40px !important;
  right: 50px !important;
}

@media only screen and (max-width: 767px) {
  /deep/ .moda {
    padding: 20vw !important;
  }

  /deep/ .close-img {
    width: 30px !important;
    height: 30px !important;
    opacity: 0;
    top: 10px !important;
    right: 15px !important;
  }
}

// 注册弹窗
@font-face {
  font-family: "UTMMabella";
  src: url("../assets/font/UTM-Mabella.ttf");
}

.myDialog-enter-active,
.myDialog-leave-active {
  transition: all 0.3s;
}

.myDialog-enter,
.myDialog-leave-to {
  opacity: 0;
}

.dialog-tip {
  font-size: 18px;
  margin-top: 12px;
  color: #fffcfc;
  font-family: "Montserrat";
  font-weight: 100;
}

.form-container {
  position: relative;
  .form {
    width: 2.5rem;
    height: auto;
    margin-top: 0;
    //padding-bottom: 0.203rem;
    background: rgba(0, 0, 0, 0.5);
    // background-image: url("../assets/sport5/bgi-form.png");
    background-size: 100% 100%;
    background-size: contain;

    &.login {
      // background-image: url("../assets/sport5/bgi-form-login.png");
      height: auto;

      .tags {
        width: 102%;
      }
    }

    .tags {
      width: 100%;
      position: relative;
      top: -0.323rem;
      height: 0.323rem;
      display: flex;
      align-items: center;
      justify-content: center;

      .tag {
        flex: 1;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-image: url("../assets/sport8/tag-login.png");
        background-size: 100% 100%;
        cursor: pointer;
        position: relative;

        &.register {
          background-image: url("../assets/sport8/tag-regist.png");
        }

        &.active {
          background-image: url("../assets/sport8/tag-login-active.png");
          &.register {
            background-image: url("../assets/sport8/tag-regist-active.png");
          }
        }
      }
    }

    .inputs {
      height: auto;
      margin-top: -0.15rem;
      .bottom-tips {
        display: none;
      }
    }

    .form-input {
      width: 2.115rem;
      height: auto;
      margin: 0 auto;
      font-size: 0;
      position: relative;

      a.error {
        position: absolute;
        right: 0px;
        bottom: 5px;
        color: #ffffff;
        display: inline-block;
        font-size: 12px;
        text-decoration: none;
        text-align: center;
      }
      &__item {
        position: relative;
        display: flex;
      }

      .errMsg {
        font-size: 12px;
        color: #ff0000;
        height: 0.15rem;
        line-height: 0.15rem;
        display: inline-block;
        &.longErrMsg {
          left: 50%;
          width: 100%;
          transform: translateX(-50%);
        }
      }
      img {
        width: 0.104rem;
        height: 0.104rem;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 0.073rem;
      }
      .form-input__code {
        width: 0.656rem;
        height: 0.24rem;
        display: block;
        margin-left: 0.078rem;
        position: relative;
        img {
          width: 100% !important;
          height: 100% !important;
          left: 0 !important;
          right: 0 !important;
          bottom: 0 !important;
        }
      }

      input {
        flex: 1;
        height: 0.24rem;
        border-radius: 0.052rem;
        background: #fff;
        border: none;
        outline: none;
        text-indent: 0.234rem;
        font-size: 0.094rem;
        color: #000;
        &::placeholder {
          color: #6b6b6b;
          opacity: 0.9;
          font-size: 14px;
          // 这里让浏览器自动去判断
          line-height: normal;
        }
      }
    }

    .submitBtn {
      margin: 0 auto;
      cursor: pointer;
      position: relative;
      bottom: 20px;
      img {
        width: 100%;
        height: 100%;
      }
      &.reg {
        width: 2.203rem;

      }

      &.login {
        width: 2.25rem;
      }
    }
  }

  .form-close-img {
    position: absolute;
    top: -39px;
    right: -36px;
    width: 55px;
    height: 55px;
    cursor: pointer;
  }

  &.isMobile {
    .form {
      width: 7.907rem;
      height: auto;
      display: flex;
      flex-direction: column;
      align-items: center;

      a.error {
        right: -6px;
      }

      .tags {
        margin: 0 auto;
        width: 100%;
        height: 0.933rem;
        top: -0.933rem;
        .tag {
          flex: 1;
          height: 100%;
        }
      }

      .inputs {
        height: auto;
        .bottom-tips {
          display: none;
        }
      }

      .form-input {
        width: 7.053rem;
        height: auto;
        margin: 0 auto;
        font-size: 0;

        &__item {
          position: relative;
          display: flex;
        }

        .errMsg {
          font-size: 12px;
          color: #ff0000;
          height: 0.64rem;
          line-height: 0.64rem;
          display: inline-block;
          &.longErrMsg {
            left: 50%;
            width: 100%;
            transform: translateX(-50%);
          }
        }
        img {
          width: 0.267rem;
          height: 0.267rem;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: 0.2rem;
        }
        .form-input__code {
          width: 1.747rem;
          height: 0.667rem;
          display: block;
          margin-left: 0.16rem;
        }

        input {
          flex: 1;
          height: 0.667rem;
          border-radius: 0.133rem;
          background: #fff;
          border: none;
          outline: none;
          text-indent: 0.613rem;
          font-size: 0.32rem;
          color: #000;
          &::placeholder {
            color: #6b6b6b;
            opacity: 0.9;
            font-size: 14px;
            // 这里让浏览器自动去判断
            line-height: normal;
          }
        }
      }

      .submitBtn {
        width: 5.64rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Sport8.vue